import React, { useState, useEffect } from "react";
import store from "../../../store";
import { connect } from "react-redux";
import { stopTimer } from "../common/helper";
import Radio from "../../common/input/radio";
import PnrTicket from "../common/pnrTicket";
import TripCode from "./tripCode";
import PnrService from "./pnrService";

import {
  t,
  SEARCH_BY,
  PNR_TICKET_NO,
  TRIP_CODE,
  ENTER_PNR_NUMBRE,
} from "../../../translations/pnrEnquiry/Trip/Trip";

const tripstatusType = [
  {
    text: `${t(PNR_TICKET_NO)}`,
    code: "pnr",
  },
  {
    text: `${t(TRIP_CODE)}`,
    code: "tripcode",
  },
];
const Trip = () => {
  const props = store.getState();
  const [page, setPage] = useState("pnr");

  const propdata = store.getState();
  const tripData = propdata.search.pnrEnquiryTripData;

  useEffect(() => {
    stopTimer();
  }, []);

  const showTripInput = (page) => {
    switch (page) {
      case "pnr":
        return <PnrService statusFor={"trip"} />;
      case "tripcode":
        return <TripCode statusFor={"trip"} />;
      default:
        return null;
    }
  };

  return (
    <>
      {
        <div
          className="bookingStatus_container"
          style={
            Object.keys(tripData.topDtls).length > 0
              ? { padding: "0" }
              : { padding: "16px", width: "100%" }
          }
        >
          {Object.keys(tripData.topDtls).length === 0 &&
            Object.keys(tripData.topDtls).length === 0 && (
              <div
                className="bookingStatus-radio"
                style={{ paddingBottom: "16px" }}
              >
                <p style={{ color: "#444444", margin: "0" }}>{t(SEARCH_BY)}:</p>
                <div className="radio">
                  {tripstatusType.length > 0 &&
                    tripstatusType.map((el) => (
                      <div
                        key={el.code}
                        className="inputs"
                        onClick={() => setPage(el.code)}
                      >
                        <Radio active={el.code === page} />
                        <span
                          style={{
                            marginLeft: "8px",
                            color: "#444",
                            fontWeight: "500",
                            textTransform: "capitalize",
                            letterSpacing: "0.28px",
                          }}
                        >
                          {el.text}
                        </span>
                      </div>
                    ))}
                </div>
              </div>
            )}
          {showTripInput(page)}
        </div>
      }
    </>
  );
};

const mapStateToProps = function (store) {
  return store;
};

export default connect(mapStateToProps)(Trip);
